// Internal modules
import { appStore, dispatchFormAction } from '@/store';
import { getFieldError } from '@/lib';

// Factory to create a change handler/callback for when the card types change.
// These functions are passed the fields that rely on the card type/allowed
// card types for validating their inputs (e.g. cardNumber, cardCvv, etc)
const createCardTypesChangeHandlerForField =
  field =>
  ({ cardFieldsToDisplay, cardType, validation }) => {
    const { form: formState, ui: uiState } = appStore.getState();
    const { ui: uiActions } = appStore.getActions();
    const { displayError, value } = formState[field];
    const { errors, isValid } = validation;
    const errorCode = errors[0] || '';
    const includeCardType =
      field === 'cardNumber' && !uiState.hasCardTypeSelector;
    const payload = {
      ...(includeCardType && { cardType }),
      displayError: displayError && !isValid,
      error: getFieldError({ errorCode, field, isValid, value }),
      errorCode,
      isValid,
    };

    if (cardFieldsToDisplay) {
      uiActions.setCardFieldsToDisplay(cardFieldsToDisplay);
    }

    dispatchFormAction({ field, payload });
  };

export { createCardTypesChangeHandlerForField };
